/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramFavouritesUserControllerToggleMutationRequest,
  TelegramFavouritesUserControllerToggleMutationResponse,
  TelegramFavouritesUserControllerToggle401,
} from '../../types/TelegramFavouritesUserControllerToggle.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramFavouritesUserToggle } from '../../methods/telegramFavouritesUserToggle.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramFavouritesUserToggleMutationKey = () => [{ url: '/api/user/telegram/favourites/toggle' }] as const;

export type TelegramFavouritesUserToggleMutationKey = ReturnType<typeof telegramFavouritesUserToggleMutationKey>;

/**
 * {@link /api/user/telegram/favourites/toggle}
 */
export function useTelegramFavouritesUserToggle<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramFavouritesUserControllerToggleMutationResponse,
      ResponseErrorConfig<TelegramFavouritesUserControllerToggle401>,
      { data: TelegramFavouritesUserControllerToggleMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramFavouritesUserControllerToggleMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramFavouritesUserToggleMutationKey();

  return useMutation<
    TelegramFavouritesUserControllerToggleMutationResponse,
    ResponseErrorConfig<TelegramFavouritesUserControllerToggle401>,
    { data: TelegramFavouritesUserControllerToggleMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramFavouritesUserToggle(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
